import React, { useState } from "react";
import { AccelerateInvoiceModal } from "../modals/AccelerateInvoiceModal";
import { AddOneTimeExpenseModal } from "../modals/AddOneTimeExpenseModal";
import { AddOneTimeIncomeModal } from "../modals/AddOneTimeIncomeModal";
import { AddRecurringExpenseModal } from "../modals/AddRecurringExpenseModal";
import { DelayBillModal } from "../modals/DelayBillModal";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { DelayInvoiceModal } from "./DelayInvoiceModal";

interface QuickAdjustmentsModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSelectAdjustment?: (adjustmentType: string, adjustmentData?: any) => void;
}

export const QuickAdjustmentsModal: React.FC<QuickAdjustmentsModalProps> = ({
  open,
  onOpenChange,
  onSelectAdjustment,
}) => {
  const [delayInvoiceModalOpen, setDelayInvoiceModalOpen] = useState(false);
  const [accelerateInvoiceModalOpen, setAccelerateInvoiceModalOpen] =
    useState(false);
  const [delayBillModalOpen, setDelayBillModalOpen] = useState(false);
  const [oneTimeIncomeModalOpen, setOneTimeIncomeModalOpen] = useState(false);
  const [oneTimeExpenseModalOpen, setOneTimeExpenseModalOpen] = useState(false);
  const [recurringExpenseModalOpen, setRecurringExpenseModalOpen] =
    useState(false);

  const handleDelayInvoiceClick = () => {
    onOpenChange(false);
    setDelayInvoiceModalOpen(true);
  };

  const handleAccelerateInvoiceClick = () => {
    onOpenChange(false);
    setAccelerateInvoiceModalOpen(true);
  };

  const handleDelayBillClick = () => {
    onOpenChange(false);
    setDelayBillModalOpen(true);
  };

  const handleOneTimeIncomeClick = () => {
    onOpenChange(false);
    setOneTimeIncomeModalOpen(true);
  };

  const handleOneTimeExpenseClick = () => {
    onOpenChange(false);
    setOneTimeExpenseModalOpen(true);
  };

  const handleRecurringExpenseClick = () => {
    onOpenChange(false);
    setRecurringExpenseModalOpen(true);
  };

  return (
    <>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>Quick Adjustments</DialogTitle>
          </DialogHeader>

          <div className="space-y-4">
            <p className="text-sm text-muted-foreground">
              Make simple, one-off adjustments to your scenario.
            </p>

            <div className="space-y-2">
              <Button
                variant="outline"
                className="w-full justify-start"
                onClick={handleDelayInvoiceClick}
              >
                Delay an invoice
              </Button>
              <Button
                variant="outline"
                className="w-full justify-start"
                onClick={handleAccelerateInvoiceClick}
              >
                Accelerate invoice payment
              </Button>
              <Button
                variant="outline"
                className="w-full justify-start"
                onClick={handleDelayBillClick}
              >
                Delay bill payment
              </Button>
              <Button
                variant="outline"
                className="w-full justify-start"
                onClick={handleOneTimeIncomeClick}
              >
                Add one-time income
              </Button>
              <Button
                variant="outline"
                className="w-full justify-start"
                onClick={handleOneTimeExpenseClick}
              >
                Add one-time expense
              </Button>
              <Button
                variant="outline"
                className="w-full justify-start"
                onClick={handleRecurringExpenseClick}
              >
                Add recurring expense
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      <DelayInvoiceModal
        open={delayInvoiceModalOpen}
        onOpenChange={setDelayInvoiceModalOpen}
        onAddAdjustment={(adjustmentData) => {
          if (onSelectAdjustment) {
            onSelectAdjustment("delay_invoice", adjustmentData);
          }
        }}
      />

      <AccelerateInvoiceModal
        open={accelerateInvoiceModalOpen}
        onOpenChange={setAccelerateInvoiceModalOpen}
        onAdd={(adjustmentData) => {
          if (onSelectAdjustment) {
            onSelectAdjustment("accelerate_invoice", adjustmentData);
          }
        }}
      />

      <DelayBillModal
        open={delayBillModalOpen}
        onOpenChange={setDelayBillModalOpen}
        onAdd={(adjustmentData) => {
          if (onSelectAdjustment) {
            onSelectAdjustment("delay_bill", adjustmentData);
          }
        }}
      />

      <AddOneTimeIncomeModal
        open={oneTimeIncomeModalOpen}
        onOpenChange={setOneTimeIncomeModalOpen}
        onAdd={(adjustmentData) => {
          if (onSelectAdjustment) {
            onSelectAdjustment("one_time_income", adjustmentData);
          }
        }}
      />

      <AddOneTimeExpenseModal
        open={oneTimeExpenseModalOpen}
        onOpenChange={setOneTimeExpenseModalOpen}
        onAdd={(adjustmentData) => {
          if (onSelectAdjustment) {
            onSelectAdjustment("one_time_expense", adjustmentData);
          }
        }}
      />

      <AddRecurringExpenseModal
        open={recurringExpenseModalOpen}
        onOpenChange={setRecurringExpenseModalOpen}
        onAdd={(adjustmentData) => {
          if (onSelectAdjustment) {
            onSelectAdjustment("recurring_expense", adjustmentData);
          }
        }}
      />
    </>
  );
};
